import logger from "@/utils/logger";
import { BannerAuctionType } from "@/utils/topsortUtil";

export async function getAuctionResult(
  slotIds: string[],
  device: "desktop" | "mobile",
  apiKey: string,
  auctionType: BannerAuctionType = "landing",
  filter: string | string[] | null = null,
  signal?: AbortSignal,
): Promise<AuctionResponse | null> {
  try {
    const auctionTypeList: AuctionType[] = [];

    slotIds.forEach((slotId) => {
      if (auctionType === "category" && filter) {
        auctionTypeList.push({
          type: "banners",
          slots: 1,
          slotId: slotId,
          device: device,
          // A list matches campaigns that target any one of its categories.
          category: Array.isArray(filter) ? { disjunctions: [filter] } : { id: filter },
        });
      } else if (auctionType === "searchQuery" && typeof filter === "string") {
        auctionTypeList.push({
          type: "banners",
          slots: 1,
          slotId: slotId,
          device: device,
          searchQuery: filter,
        });
      } else {
        auctionTypeList.push({
          type: "banners",
          slots: 1,
          slotId: slotId,
          device: device,
        });
      }
    });

    const auctionRequest: AuctionRequest = {
      auctions: auctionTypeList,
    };

    const res = await fetch("https://api.topsort.com/v2/auctions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${apiKey}`,
      },
      body: JSON.stringify(auctionRequest),
      signal,
    });

    if (!res.ok) {
      const errorBody = await res.text().catch(() => "(unreadable)");
      logger.error("Topsort auction request failed", { status: res.status, body: errorBody, auctionRequest });
      return null;
    }

    const response = (await res.json()) as AuctionResponse;
    return response;
  } catch (error) {
    logger.error("Topsort Error", error);
    return null;
  }
}
